var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"p-0 text-white-50",staticStyle:{"height":"1.5rem","z-index":"9"},attrs:{"id":"sticky-footer"}},[_c('div',{staticClass:"container text-center p-0"},[_c('small',[_vm._v("Copyright © Workflowlabs.com")])])])
}]

export { render, staticRenderFns }